import { Directive, EventEmitter, Input, Output } from '@angular/core';

@Directive()
export abstract class BaseModalComponent<T = null> {
  @Input() openModal = false;
  @Output() openModalChange = new EventEmitter<boolean>();

  enableCloseOutside = false;
  @Input() dataModal: T | null = null;

  onModalCloseClick(value: boolean): void {
    //for template
    this.modalCloseClick(!value);
  }

  /**
   *
   * @param value = false to close the modal
   */
  modalCloseClick(value: boolean) {
    //for code
    this.openModal = value;
    this.openModalChange.emit(this.openModal);
  }
}
